module.exports = "<home-header></home-header>\n<p>\n  event-listing works!\n</p>\n<home-footer></home-footer>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/home/event-listing/event-listing.component.html
// module id = ../../../../../src/app/home/event-listing/event-listing.component.html
// module chunks = 39